import { Injectable } from '@angular/core';
import { ApiClientService } from '../api-client.service';

import { Observable } from 'rxjs/Observable';
import { IServiceRequestComment } from '../../types/api-response/service-request/service-request-comment';
import { IServiceRequest } from '../../types/api-response/service-request/service-request';
import { IServiceRequestAssign } from '../../types/api-response/service-request/service-request-assign';

@Injectable()
export class ServiceRequestApiService {

    constructor(private api: ApiClientService) {}

    /**
     * Adds new comment to service request
     *
     * @param comment
     */
    addComment(comment: IServiceRequestComment): Observable<IServiceRequestComment> {
       return this.api.post('domainServiceRequest', '/v1/service_request_comments.json', comment);
    }

    /**
     * Updates service request
     *
     * @param id
     * @param serviceRequest
     */
    updateServiceRequest(id, serviceRequest: Partial<IServiceRequest>): Observable<IServiceRequest> {
        return this.api.patch('domainServiceRequest', `/v1/service_request/${id}.json`, serviceRequest);
    }

    /**
     * Assign service request
     *
     * @param id
     * @param serviceRequestAssign
     */
    assignServiceRequest(id, serviceRequestAssign: Partial<IServiceRequestAssign>) {
        return this.api.patch('domainServiceRequest', `/v1/service_request/${id}/assign`, ApiClientService.filter(serviceRequestAssign));
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/api/service-request-api.service.ts